import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import LeaseEdit from './LeaseEdit';

const EditLease = () => {
    const { t } = useTranslation();
    return (
        <Fragment>
            <Breadcrumbs mainTitle={t('View Tenant Lease Detail')} parent={t('Tenant')} title={t('Lease Edit')} />
            <Container fluid={true}>
                <div className='edit-profile'>
                    <Row>
                        <LeaseEdit />
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default EditLease